import React from 'react';
import {List, ListItem} from 'material-ui/List';
import {CardTitle, Card, CardText} from 'material-ui/Card';
import Button from 'material-ui/RaisedButton';
import Bookmark from 'material-ui/svg-icons/action/bookmark';
import {Link} from 'react-router';
import PropTypes from 'prop-types';
import NoteIcon from "material-ui/svg-icons/action/find-in-page";
import {noteIconColor} from "../components/resultItems/Notes";
import { questionsForSection } from "../reducer";

class FlaggedQuestionList extends React.Component {

  render() {
    let props = this.props;
    let {responseID} = this.props;
    let questions = props.questions;

    //sort into questionnaire order
    let questionsSectionOrder = questionsForSection(global.store.getState());
    questionsSectionOrder = questionsSectionOrder.map(q => q.id)
    questions.sort((a, b) => questionsSectionOrder.indexOf(a.id) - questionsSectionOrder.indexOf(b.id))

    if (questions && questions.length) {
      return (
        <List>
          <Card initiallyExpanded={true}>
            <CardTitle showExpandableButton={true}  title="Bookmarked Questions" subtitle="These answers were flagged in the questionnaire with the Bookmark feature for later review." />
            <CardText expandable={true} >
            {
              questions.map((question) => {
                let qTitle = question.title
                let answerText = props.answerTextLookup[question.id]
                if(props.translation){
                  var trQ = this.props.translation.questions.find(trQ => trQ.engID === question.id)
                  if(trQ){
                      qTitle = trQ.title
                      let answerID = question.answers.find(a => a.title === answerText).id
                      answerText = trQ.answers.find(a => a.id === answerID).title
                  }
                }
                let rightIcon = question.answer.note ? <NoteIcon color={noteIconColor} /> : null;
                return (
                  <ListItem
                    key={question.id}
                    leftAvatar={<Bookmark color="green" />}
                    primaryText={qTitle.replace(/<.*?>/gm, '')}
                    secondaryText={answerText}
                    onClick={this.onItemClick.bind(this, question.id)}
                    rightIcon={rightIcon}
                  />
                )
              })
            }

              <Button containerElement={<Link to={`/questionnaire/results/${responseID}/answers`} />} label="See all Answers" />
            </CardText>
          </Card>
        </List>
      )
    } else {
      return (
        <div>
        </div>
      )
    }
  }

  onItemClick(id) {
    if (this.props.onItemClick) {
      this.props.onItemClick(id);
    }
  }
}

FlaggedQuestionList.propTypes = {
  questions: PropTypes.array.isRequired,
}

export default FlaggedQuestionList;
